import { storeIsTelevendas, loadIsTelevendas } from './store'

const manageIsTelevendasMixin = {
  methods: {
    storeIsTelevendas (val) {
      return storeIsTelevendas(val)
    },
    loadIsTelevendas () {
      return loadIsTelevendas()
    }
  }
}

export { manageIsTelevendasMixin }
